(function () {
  var GTE_PARAM = 'filter.v.price.gte';
  var LTE_PARAM = 'filter.v.price.lte';

  // コレクションの実際の価格 min/max を details 要素のデータ属性から取得する
  function getPriceRange() {
    var details = document.querySelector('.js-filter[data-index="mobile-price"]');
    return {
      min: details ? parseInt(details.dataset.rangeMin, 10) || 0 : 0,
      max: details ? parseInt(details.dataset.rangeMax, 10) || Infinity : Infinity,
    };
  }

  function getCheckedRanges() {
    var result = [];
    document.querySelectorAll('.price-range-radio:checked').forEach(function (cb) {
      result.push({
        gte: cb.dataset.gte !== '' ? parseInt(cb.dataset.gte, 10) : null,
        lte: cb.dataset.lte !== '' ? parseInt(cb.dataset.lte, 10) : null,
      });
    });
    return result;
  }

  function computeUnion(ranges) {
    var minGte = null;
    var maxLte = null;
    var hasOpenLow = false;
    var hasOpenHigh = false;
    ranges.forEach(function (r) {
      if (r.gte === null) { hasOpenLow = true; }
      else { minGte = minGte === null ? r.gte : Math.min(minGte, r.gte); }
      if (r.lte === null) { hasOpenHigh = true; }
      else { maxLte = maxLte === null ? r.lte : Math.max(maxLte, r.lte); }
    });
    return {
      gte: hasOpenLow ? null : minGte,
      lte: hasOpenHigh ? null : maxLte,
    };
  }

  function buildUnionUrl(ranges, removeHref) {
    var url = new URL(removeHref, window.location.href);
    url.searchParams.delete(GTE_PARAM);
    url.searchParams.delete(LTE_PARAM);

    if (!ranges.length) return url.toString();

    var union = computeUnion(ranges);

    if (union.gte === null && union.lte === null) {
      // 全価格帯を包含するユニオン → コレクションの実際の min〜max を明示的に指定
      var range = getPriceRange();
      url.searchParams.set(GTE_PARAM, range.min);
      url.searchParams.set(LTE_PARAM, range.max);
    } else {
      if (union.gte !== null) url.searchParams.set(GTE_PARAM, union.gte);
      if (union.lte !== null) url.searchParams.set(LTE_PARAM, union.lte);
    }
    return url.toString();
  }

  function syncPriceRangeState() {
    var params = new URLSearchParams(window.location.search);
    var urlGte = params.get(GTE_PARAM);
    var urlLte = params.get(LTE_PARAM);

    if (urlGte === null && urlLte === null) {
      document.querySelectorAll('.price-range-radio').forEach(function (cb) { cb.checked = false; });
      return;
    }

    var range = getPriceRange();
    var numGte = urlGte !== null ? parseInt(urlGte, 10) : null;
    var numLte = urlLte !== null ? parseInt(urlLte, 10) : null;
    // null は「コレクションの端値（min/max）と等価」として比較する
    var numGteEff = numGte !== null ? numGte : range.min;
    var numLteEff = numLte !== null ? numLte : range.max;

    document.querySelectorAll('.price-range-radio').forEach(function (cb) {
      var cbGte = cb.dataset.gte !== '' ? parseInt(cb.dataset.gte, 10) : null;
      var cbLte = cb.dataset.lte !== '' ? parseInt(cb.dataset.lte, 10) : null;
      var cbGteEff = cbGte !== null ? cbGte : range.min;
      var cbLteEff = cbLte !== null ? cbLte : range.max;

      // チェックボックスの範囲が URL フィルター範囲に完全に含まれていればチェック済み
      cb.checked = cbGteEff >= numGteEff && cbLteEff <= numLteEff;
    });
  }

  // 価格フィルター以外のフォーム入力が変更された際、現在の価格パラメーターを
  // hidden input としてフォームに注入する（キャプチャフェーズで Dawn より先に実行）
  document.addEventListener('change', function (event) {
    if (event.target.classList.contains('price-range-radio')) return;
    var form = event.target.closest('facet-filters-form form');
    if (!form) return;

    form.querySelectorAll('input[data-price-hidden]').forEach(function (el) { el.remove(); });

    var params = new URLSearchParams(window.location.search);
    var urlGte = params.get(GTE_PARAM);
    var urlLte = params.get(LTE_PARAM);

    function addHidden(paramName, value) {
      var el = document.createElement('input');
      el.type = 'hidden';
      el.name = paramName;
      el.value = value;
      el.setAttribute('data-price-hidden', '1');
      form.appendChild(el);
    }

    if (urlGte !== null) addHidden(GTE_PARAM, urlGte);
    if (urlLte !== null) addHidden(LTE_PARAM, urlLte);
  }, true);

  // FacetFiltersForm が price-range-radio の input イベントを拾わないようにする
  document.addEventListener('input', function (event) {
    if (event.target.classList.contains('price-range-radio')) {
      event.stopPropagation();
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target.classList.contains('price-range-radio')) return;

    var form = document.querySelector('facet-filters-form');
    if (!form) return;

    var anyRadio = document.querySelector('.price-range-radio');
    var removeHref = anyRadio ? anyRadio.dataset.removeHref : window.location.href;

    var ranges = getCheckedRanges();
    var newUrl = buildUnionUrl(ranges, removeHref);

    form.onActiveFilterClick({
      preventDefault: function () {},
      currentTarget: { href: newUrl },
    });
  });

  // AJAX でフィルター DOM が差し替えられた後もチェック状態を維持する
  function observePriceFilter() {
    var details = document.querySelector('.js-filter[data-index="mobile-price"]');
    if (!details) return;
    new MutationObserver(function () {
      syncPriceRangeState();
    }).observe(details, { childList: true, subtree: true });
  }

  syncPriceRangeState();
  observePriceFilter();
})();
